import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { new_ErrorAlert } from "./ExportManager";
import { GovRow } from "./GovRow";
import { SpwkGovStep } from "./GovRowHelper";
import { 申報通用解碼 } from "./GovRowParser_既往病史_自覺症狀";
import { HisBasic } from "./HisBasic";
import { SpwkMetaTable } from "./SpwkMetaTable";


export class GovRowParser_B02既往病史_B02自覺症狀 {

  static ConvertToHisRow(func_guid: string, func_code: string, step: SpwkGovStep, 基本檔: HisBasic, meta_table: SpwkMetaTable): GovRow[] {

    if (step.Chapter !== SpwkUtilV3.CHAPTER_既往病史_噪音作業 && step.Chapter !== SpwkUtilV3.CHAPTER_自覺症狀_噪音作業) {
      throw new Error("4984651 必須是 CHAPTER_既往病史_噪音作業 或  CHAPTER_自覺症狀_噪音作業 !!!");
    }

    if (func_code === SpwkUtilV3.A01_func_guid || func_code === SpwkUtilV3.A98_func_guid) {
      throw new_ErrorAlert("4684143 A01、A98 還沒有轉申報格式 !!!")
    }

    let gov_row_CH4_0302: GovRow | null = null;

    let re: GovRow[] = [];

    let q_meta_list = meta_table.FilterQuestions_ByChapter(step.Chapter);

    for (const q_meta of q_meta_list) {
      if (q_meta.q_gov_code == null || q_meta.q_gov_code === "") {
        continue;  // pass; 目前不處理沒有指定申報代碼的題目
      }

      if (step.Chapter === SpwkUtilV3.CHAPTER_既往病史_噪音作業 && q_meta.q_gov_code === "0302") {
        const gov_row = 申報通用解碼(q_meta, 基本檔, step, meta_table);
        re.push(gov_row);

        gov_row_CH4_0302 = gov_row;

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_既往病史_噪音作業 && q_meta.q_gov_code === "0302-part2") {

        if (gov_row_CH4_0302 == null) {
          throw new_ErrorAlert("4786846 應該要先遇到 gov_row_CH4_0302 !!!");
        }

        const gov_row_part2 = 申報通用解碼(q_meta, 基本檔, step, meta_table);

        let ori_ans = gov_row_CH4_0302.答題內容;
        gov_row_CH4_0302.答題內容 += gov_row_part2.答題內容.substring(ori_ans.length);

        // re.push(gov_row);// 答案已加入 0302，不需要再次加入 list

      } else if (step.Chapter === SpwkUtilV3.CHAPTER_自覺症狀_噪音作業 && q_meta.q_gov_code === "0104") {
        const gov_row: GovRow = new GovRow(基本檔, step.Gov問卷類別);
        gov_row.問題編號 = "0104";
        gov_row.答題內容 = "1"; // 總是視為打勾  (題目: 如果有，您知道是什麼原因造成的嗎？請詳細描述...)

        var input_meta_list = meta_table.FilterInputs_ByQuestionGuid(q_meta.question_guid);
        if (input_meta_list.length !== 1) {
          throw new_ErrorAlert("4648324 B02.0104 應該要剛好有一個 input !!!");
        }

        let rhf_value = input_meta_list[0].rhf_value ?? "";

        gov_row.答題內容_1 = rhf_value;

        re.push(gov_row);
      } else {
        const gov_row = 申報通用解碼(q_meta, 基本檔, step, meta_table);
        re.push(gov_row);
      }



    }

    return re;
  }

}